import { render, staticRenderFns } from "./HtmlInput.vue?vue&type=template&id=4fed13a5"
import script from "./HtmlInput.vue?vue&type=script&lang=js"
export * from "./HtmlInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports